module.exports = __webpack_public_path__ + "static/media/about.9507d72d.svg";